import { t } from "ttag";

import { MONTHLY_CAP_CREDIT } from "@/shared/domains/referral";
import { Alert, GiftIcon } from "@/shared/ui";

export const CreditLimitReachedAlert = () => {
  return (
    <Alert icon={GiftIcon}>
      <h4>{t`You've already used your $${MONTHLY_CAP_CREDIT} monthly credit`}</h4>
    </Alert>
  );
};
